import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
    getEmployeeDetails
} from "../../../../../redux/employee/employeeState";
import InfoCard from "components/card/InfoCard";
import DetailCard from "components/card/DetailCard";
import AccessButton from "components/button/accessbutton";
import ProfileHeader from "components/card/ProfileHeader";
import { 
    Mail,
    Phone,
    Briefcase,
    MapPin,
    Building2,
    CircleUser,
    FileText,
    ExternalLink,
} from "lucide-react";

const ProfileDetails = ({
    getDetails,
    recordData,
    recordId,
}) => {

    useEffect(() => {
        getDetails(recordId);
    }, [getDetails, recordId]);

    return (
        <div className="grid w-full bg-white gap-4 border rounded-lg shadow-lg p-6 dark-mode-card">
            <div className="flex flex-col gap-2 text-left">
                <h1 className="text-xl font-semibold leading-snug title-text">Employee Details</h1>
                <p className="text-base leading-tight muted-text">Complete information for {recordData?.user_detail?.full_name}</p>
            </div>
            <div className="space-y-6">
                <ProfileHeader
                    initials={recordData?.employee_initials}
                    fullName={recordData?.user_detail?.full_name}
                    designation={recordData?.emp_title}
                    clientName={recordData?.client_name}
                    employmentStatus={recordData?.employment_status_name}
                    variant="light"
                />
                <div className="grid grid-cols-2 gap-4">
                    {/* <InfoCard 
                        label="Email"
                        icon={<Mail />}
                        value={recordData?.emp_email}
                    />
                    <InfoCard 
                        label="Phone"
                        icon={<Phone />}
                        value={recordData?.user_detail?.contact_details?.cde_mobile_number}
                    /> */}
                    <InfoCard 
                        label="Department"
                        icon={<Briefcase />}
                        value={recordData?.department_name}
                    />
                    <InfoCard 
                        label="Location"
                        icon={<MapPin />}
                        value={recordData?.user_detail?.address?.country?.cou_name}
                    />
                    {/* <InfoCard 
                        label="Client Name"
                        icon={<Building2 />}
                        value={recordData?.client_name}
                        span="col-span-2"
                    /> */}
                </div>
                <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
                    <DetailCard
                        title="Additional Information"
                        details={[
                            { 
                                label: "Employee ID", 
                                value: recordData?.emp_code
                            },
                            { 
                                label: "Join Date", 
                                value: recordData?.emp_hire_date 
                            },
                            { 
                                label: "Reports To", 
                                value: recordData?.reports_to || "" 
                            },
                        ]}
                    />
                    <DetailCard
                        title="Emergency Contact"
                        icon={CircleUser}
                        details={[
                            { 
                                label: "Name", 
                                value: recordData?.user_detail?.emergency_contact_person?.contact_full_name 
                            },
                            { 
                                label: "Relationship", 
                                value: recordData?.user_detail?.emergency_contact_person?.cde_relation 
                            },
                            { 
                                label: "Phone", 
                                value: recordData?.user_detail?.emergency_contact_person?.cde_mobile_number 
                            },
                        ]}
                    />
                </div>
                <AccessButton
                    label="Access Employee Documents & Contracts"
                    baseRoute={`/console/employee-details`}
                    recordId={recordId}
                    recordData={recordData}
                    iconStart={<FileText />}
                    iconEnd={<ExternalLink />}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getDetails: (data) => dispatch(getEmployeeDetails(data)),
});


export default connect(mapStateToProps, mapDispatchToProps)(ProfileDetails);